import { Text, Center } from '@mantine/core';

export const NoDucksFound = () => {
  return (
    <Center py="xl">
      <Text c="dimmed">
        No ducks found. Add some ducks to get started!
      </Text>
    </Center>
  );
};
